import React, { Component } from "react";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import StepHeader from "./StepHeader";

class LangSelector extends Component {
	constructor(props) {
		super(props);
		this.handlecheckbox = this.handlecheckbox.bind(this);
	}
	
	handlecheckbox(e){
		//console.log('handlecheckbox ['+e.target.value+'] ]: '+e.target.checked);
		this.props.updateLang(e.target.value, e.target.checked);
	}
	
	render() {
		//console.log('render [TaskSelector]');
		let products = [];
		this.props.product.forEach((product) => {
			var sufix="";
			if(product.langPair!==null){
				sufix=" "+product.langPair.code;
			}
			products.push(<Grid item  xs={6}><FormControlLabel
					control={
						<Checkbox
							defaultChecked={false}
							value={product.id}
							color="primary"
							onChange={this.handlecheckbox}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>{sufix}</Typography>}
					
				/></Grid>)
		});
		return (
			<Grid container item direction="column" alignItems="flex-start" justify="flex-start" spacing={0} xs={12}>
				<StepHeader index={this.props.stepIndex} title={this.props.stepTitle} active={true}  first={false}/>
				<Grid container item direction="row" alignItems="flex-start" justify="flex-start" spacing={0} xs={12}>
					{products}
				</Grid>
			</Grid>
		);
	}
}

export default LangSelector;